import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Spinner from '../../../../../components/Spinner';
import useFetch from '../../../../../hooks/useFetch';
import DashboardService from '../../../../../services/dashboard.service';
import { formatNumber } from '../../../../../utils/methods';
import { MonthYearValue } from './MonthYearFilter';
import { ViewMode } from './ViewModeToggle';

interface CompanySecondaryProps {
  period: MonthYearValue;
  viewMode: ViewMode;
}

const CompanySecondary: React.FC<CompanySecondaryProps> = ({ period, viewMode }) => {
  const { t } = useTranslation();
  const [kpi, setKpi] = useState<{ issued_qty: number; issued_qty_value: number; closing_qty: number; closing_qty_value: number } | null>(null);

  const { loading } = useFetch({
    service: DashboardService,
    func: 'companySecondary',
    payload: { month: period.month, year: period.year },
    dependency: [period.month, period.year],
    onSuccess: (response: any) => {
      setKpi(response || null);
    },
  });

  const value = viewMode === 'value'
    ? (kpi?.issued_qty_value ?? 0)
    : (kpi?.issued_qty ?? 0);

  const description = viewMode === 'value'
    ? t('dashboard.pageTexts.companySecondary.descriptionValue')
    : t('dashboard.pageTexts.companySecondary.descriptionQty');

  return (
    <div className="col-sm-6 col-xl-3">
      <div className="card">
        <div className="card-body">
          {loading ? (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 80 }}>
              <Spinner variant="primary" />
            </div>
          ) : (
            <div className="d-flex justify-content-between align-items-start">
              <div className="me-1">
                <p className="text-heading mb-1">{t('dashboard.pageTexts.companySecondary.title')}</p>
                <div className="d-flex align-items-center">
                  <h4 className="mb-1 me-2">{formatNumber(value)}</h4>
                </div>
                <p className="text-muted small mb-0">{description}</p>
              </div>
              <div className="avatar pe-none">
                <div className="avatar-initial bg-label-success rounded-3">
                  <div className="ri-store-2-line ri-26px" />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CompanySecondary;
